import React from 'react';
import SectionTitle from '../components/CommonComps/SectionTitle';

interface ISectionLayout {
  id: string;
  children: React.ReactNode;
  titleFirstPart: string;
  titleSecondPart: string;
  additionalClassNames?: string;
  isFullWidth?: boolean;
  isBgDark?: boolean;
}

const SectionLayout = ({
  id,
  children,
  additionalClassNames,
  titleFirstPart,
  titleSecondPart,
  isFullWidth,
  isBgDark,
}: ISectionLayout) => {
  // rendering section layout component here
  return (
    <section
      id={id}
      className={`pt-20 pb-10 ${additionalClassNames} ${isFullWidth ? 'w-full' : 'w-[95%] max-w-[1800px] lg:w-[90%] xl:w-4/5 mx-auto'}`}
    >
      <SectionTitle
        titleFirstPart={titleFirstPart}
        titleSecondPart={titleSecondPart}
        isBgDark={isBgDark}
      />
      {children}
    </section>
  );
};

export default SectionLayout;
